import { httpClient } from '@/configs/axios.config'
import type { components } from '@/types/api.generated'

type MetricSearchDto = components['schemas']['MetricSearchDto']
type MetricListResponseDto = components['schemas']['MetricListResponseDto']
type PeriodType = NonNullable<
  components['schemas']['MetricSearchDto']['periodType']
>
type ScenarioType = NonNullable<
  components['schemas']['MetricSearchDto']['scenarioType']
>

export type MetricCategory = components['schemas']['MetricCategory']
export type MetricLabelOptionDto = components['schemas']['MetricLabelOptionDto']
export type MetricLabelOptionsResponseDto =
  components['schemas']['MetricLabelOptionsResponseDto']

export type CompanyMetricQuarterPointDto =
  components['schemas']['CompanyMetricQuarterPointDto']
export type CompanyMetricSeriesItemDto =
  components['schemas']['CompanyMetricSeriesItemDto']
export type CompanyMetricChangeDisplay =
  CompanyMetricSeriesItemDto['changeDisplay']
export type CompanyMetricSeriesListResponseDto =
  components['schemas']['CompanyMetricsSeriesListResponseDto']

export type CompanyMetricsView = 'MONTHLY' | 'QUARTERLY' | 'ANNUAL'

export type GetCompanyMetricsSeriesParams = {
  metricLabelIds?: string[]
  periodType?: PeriodType
  scenarioType?: ScenarioType
  quarters?: number
  months?: number
  years?: number
  view?: CompanyMetricsView
  changeBasis?: 'QOQ' | 'YOY'
}

export async function searchMetrics(
  params: MetricSearchDto
): Promise<MetricListResponseDto> {
  const response = await httpClient.post<MetricListResponseDto>(
    '/metrics/search',
    params
  )
  return response.data
}

export async function getMetricLabelOptions(params: {
  companyId: string
  periodType?: string
  scenarioType?: string
}): Promise<MetricLabelOptionsResponseDto> {
  const response = await httpClient.get<MetricLabelOptionsResponseDto>(
    '/metrics/labels/options',
    { params }
  )
  return response.data
}

export async function getCompanyMetricsSeries(
  companyId: string,
  params: GetCompanyMetricsSeriesParams
): Promise<CompanyMetricSeriesListResponseDto> {
  const response = await httpClient.get<CompanyMetricSeriesListResponseDto>(
    `/companies/${companyId}/metrics`,
    {
      params: {
        ...params,
        metricLabelIds:
          params.metricLabelIds && params.metricLabelIds.length > 0
            ? params.metricLabelIds
            : undefined,
      },
      paramsSerializer: { indexes: null },
    }
  )
  return response.data
}
